export default __webpack_public_path__ + "assets/completion-mark.ed8235dc.svg";